import useNotification from "../../hooks/useNotification";
import {Snackbar, Alert} from "@mui/material";

const config = {
  success: {
    color: "success",
    icon: "check",
  },
  error:{
    color: "error",
    icon: "warning",
  }
}
export default function AppNotification() {
  const {notification, removeNotification} = useNotification();

  return <div>
    {
      notification?
          <Snackbar

              severity={config[notification.type]["color"]}
              anchorOrigin={{ vertical: 'bottom', horizontal:'right' }}
              open={!!notification}
              onClose={removeNotification}
              message={notification.message}
          ><Alert onClose={removeNotification} severity={config[notification.type]["color"]} sx={{ width: '100%' }}>
            {notification.message}
          </Alert></Snackbar>
        : ""
    }

  </div>
}